import { BASE_API_URL } from '@/constant/api'
import { AppResp } from 'Types/api'
import { GuideStatusRecord } from '@/types/guideStatus'
import { axiosAuth } from 'Utils/axios'

const GUIDE_STATUS_PATH = '/user/guide_status'
const GUIDE_STATUS_UPDATE_PATH = '/user/guide_status/update'

export const getGuideStatus = async (keys?: string[]) => {
  const res = await axiosAuth.post<AppResp<GuideStatusRecord>>(
    `${BASE_API_URL}${GUIDE_STATUS_PATH}`,
    keys && keys.length > 0 ? { keys } : {}
  )
  return res.data.data || {}
}

export const updateGuideStatus = async (guide_status: GuideStatusRecord) => {
  const res = await axiosAuth.post<AppResp<{ updated: boolean }>>(
    `${BASE_API_URL}${GUIDE_STATUS_UPDATE_PATH}`,
    { guide_status }
  )
  return res.data.data
}
